import React from "react";
import { Route, type RouteProps, Redirect, useLocation } from "react-router-dom";
import { type LocationDescriptor } from "history";
import { useGetSessionStatusQuery } from "common/types/mainHooks";
import { broadcastLogout } from "common/utils/coordinatedLogout";
import { useAppContext } from "../AppContext";

interface PrivateRouteProps extends RouteProps {
  spoofingRedirectTo?: LocationDescriptor;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  spoofingRedirectTo,
  ...rest
}) => {
  const { user } = useAppContext();
  const location = useLocation();
  const { data: sessionData } = useGetSessionStatusQuery({
    skip: !user,
  });
  const isSpoofSession = sessionData?.session?.spoofed ?? false;
  if (isSpoofSession && spoofingRedirectTo) {
    return (
      <Route {...rest}>
        <Redirect to={spoofingRedirectTo} />
      </Route>
    );
  }

  if (user) {
    return <Route {...rest}>{children}</Route>;
  }

  const searchParams = new URLSearchParams(location.search);
  searchParams.append("path", location.pathname);
  broadcastLogout();

  return (
    <Route {...rest}>
      <Redirect to={{ pathname: "/login", search: `?${searchParams.toString()}` }} />
    </Route>
  );
};
